import React from "react";
import { Table } from "react-bootstrap";
import PaginationContainer from "../Pagination/PaginationContainer";
import styles from "./../Main.module.scss";

const TableComponent = ({ currenciesToRender, currentPage }) => {
  return (
    <Table striped bordered hover size="sm" className={styles.table}>
      <thead>
        <tr>
          <th>#</th>
          <th>Symbol</th>
          <th>Name</th>
          <th>Price</th>
          <th>Change per 24h</th>
          <th>Add</th>
        </tr>
      </thead>
      <tbody>
        {currenciesToRender}
        <tr>
          <td colSpan="6">
            <PaginationContainer currentPage={currentPage} />
          </td>
        </tr>
      </tbody>
    </Table>
  );
};

export default TableComponent;
